<div class="login-page" [attr.translate]="'no'">

  <div class="row m-0 min-vh-100">
    <div class="col-12 col-md-12 position-relative">
      <div class="row mt-5">
        <div class="col-12">
          <img src="/assets/images/logotyp_JAS-FBG.jpg" class="d-block mx-auto mt-2">
        </div>
      </div>

      <div class="mt-5">
        <div class="row images">
          <span class="p-0 col-2">
            <img src="/assets/images/logistyka.png" class="w-100 d-block">
          </span>
          <span class="p-0 col-2">
            <img src="/assets/images/krajowa.png" class="w-100 d-block">
          </span>
          <span class="p-0 col-2">
            <img src="/assets/images/kolejowa.png" class="w-100 d-block">
          </span>
          <span class="p-0 col-2">
            <img src="/assets/images/morska.png" class="w-100 d-block">
          </span>
          <span class="p-0 col-2">
            <img src="/assets/images/lotnicza.png" class="w-100 d-block">
          </span>
          <span class="p-0 col-2">
            <img src="/assets/images/agencja_celna.png" class="w-100 d-block">
          </span>
        </div>

      </div>
      <div class="box-loader">
        <div class="d-flex justify-content-center align-items-center h-100 card-body">
          @if (loading) {
            <mat-spinner class="mt-4"></mat-spinner>
          }
          @if (loginFailed) {
            <div class="login-error">
              <p class="login-error__message">Wystąpił problem z logowaniem. Spróbuj ponownie.</p>
              <button mat-raised-button color="primary" (click)="tryLogin()">Spróbuj ponownie</button>
            </div>
          }
        </div>
      </div>
      <p class="col-12 mt-5 mx-auto text-center">Pierwszy raz w serwisie? Skontaktuj się z opiekunem.</p>
    </div>
  </div>
</div>
